/*
 * サブシステム名：
 * 機能名：日報一覧
 * 表示項目カスタマイズ(滋賀自工)
 */
import D2PRMD0011 from '@/views/PRM/D2PRMD0011.js'

import DdCustomButton from '@/components/DdCustomButton'

export default {
  extends: D2PRMD0011,
  name: 'NippoListCustomForSGJ',
  components: {
    DdCustomButton
  },
  data: () => ({
    custoMizeHeaders: [
      { text: '編集', value: 'actions', sortable: false, width: '20px' },
      { text: '運行日', value: 'unkoYmdDisp' },
      { text: '配車営業所', value: 'haishaEigyoshoNm' },
      { text: '乗務員', value: 'jomuinJininNmSei' },
      { text: '傭車先', value: 'hacchusakiNm' },
      { text: '自動車表示名', value: 'jidoshaHyojiNm' },
      { text: '車種', value: 'sharyoShashuSbt' },
      { text: '出庫時オド', value: 'hatsuchiOdoMater', align: 'end' },
      { text: '帰庫時オド', value: 'chakuchiOdoMater', align: 'end' },
      { text: '売上営業所', value: 'juchuEigyoshoNm' },
      { text: '荷主', value: 'tokuisakiNm' },
      { text: '発地', value: 'hatsuchiDisp' },
      { text: '着地', value: 'chakuchiDisp' },
      { text: '商品', value: 'hinmeiNm' },
      { text: '商品備考', value: 'hinmeiBiko' },
      { text: '数量', value: 'juchuSuryoDisp', align: 'end' },
      { text: '単位', value: 'unitKbnNm' },
      { text: '重量(t)', value: 'juchuJuryoDisp', align: 'end' },
      { text: '単価', value: 'tankaDisp' },
      { text: '作業単価', value: 'warimashiKyoriTankaDisp', align: 'end' },
      { text: '作業数量', value: 'warimashiTaishoKyori', align: 'end' },
      { text: '請求計上日', value: 'seikyuYoteiYmdDisp' },
      { text: '運賃計算区分', value: 'unchinKeisanKbnNm' },
      { text: '請求金額合計', value: 'seikyuKingakuGokeiDisp', align: 'end' },
      { text: '支払計上日', value: 'shiharaiYoteiYmdDisp' },
      { text: '支払金額合計', value: 'shiharaiKingakuGokeiDisp', align: 'end' },
      { text: '荷主書面(受)', value: 'chumonshoReceiveZumiFlgDisp', align: 'center' },
      { text: '荷主書面(交付)', value: 'chumonkakuninshoSendZumiFlgDisp', align: 'center' },
      { text: '傭車書面(交付)', value: 'hacchushoSendZumiFlgDisp', align: 'center' },
      { text: '実運送報告', value: 'motoukeHokokuZumiFlgDisp', align: 'center' },
      { text: '運行実績No', value: 'unkoJissekiNo' },
      { text: '受注No', value: 'juchuNo' },
      { text: '#', value: 'meisaiOrder' }
    ],
    isPdfDownloader: false,
    dispPdfNm: ''
  }),
  computed: {
    isOutputButtonDisabled () {
      return this.filteredRows.length === 0
    }
  },
  methods: {
    getNextTransition: function () {
      const nextTransition = 1
      return nextTransition
    },
    onPdfButtonClick: function () {
      this.isPdfDownloader = true
      this.dispPdfNm = `運送作業日報_${this.getTimeStamp()}.pdf`
      const copyCon = Object.assign({}, this.conditions)
      copyCon.meisaiHeadFlg = false
      copyCon.jissekiTorokuKbn = '01'
      copyCon.haishasakiKbn = '99'

      this.HttpClient
        .requestFileByPost('/api/v1/VwCD2prmd0010/PdfDownload', copyCon).then(data => {
          // aタグにファイル仕込んでClickする処理
          if (data.type === 'application/pdf') {
            const blob = new Blob([data], { type: 'application/pdf' })
            const elem = document.getElementById('pdfDownload')
            elem.target = '_blank'
            elem.href = window.URL.createObjectURL(blob)
            elem.click()
            this.setInvalidSummaryMessage('COMI0007')
            this.Effects.loadComplete()
          } else {
            this.setInvalidSummaryMessage('COMI0101')
            this.Effects.loadComplete()
          }
          this.isPdfDownloader = false
        })
    },
    getTimeStamp () {
      var date = new Date()
      const Y = date.getFullYear()
      const M = ('00' + (date.getMonth() + 1)).slice(-2)
      const D = ('00' + date.getDate()).slice(-2)
      const h = ('00' + date.getHours()).slice(-2)
      const m = ('00' + date.getMinutes()).slice(-2)
      const s = ('00' + date.getSeconds()).slice(-2)

      return Y + M + D + h + m + s
    }
  }
}
